var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "c-project-weekplan-tooltip" },
    [
      _c(
        "p",
        {
          staticClass:
            "text-center u-extra-small-margin--top u-extra-small-margin--bottom",
        },
        [_c("strong", [_vm._v(_vm._s(_vm.$t("weeks.project.crud.add")))])]
      ),
      _vm._v(" "),
      _vm._l(_vm.weekplans, function (item, index) {
        return _c(
          "div",
          { key: index, staticClass: "grid-container" },
          [
            _c("v-weekplan-item", {
              attrs: { item: item },
              on: { onRefresh: _vm.getWeekplans },
            }),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "button button--action button--action--add-project",
          attrs: { title: _vm.$t("weeks.project.crud.add") },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.insertNewItem.apply(null, arguments)
            },
          },
        },
        [_c("span", [_vm._v(_vm._s(_vm.$t("create_new")))])]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }